export const DEFINE_MODULE = {
  name: "phòng ban",
  fields: "departments"
}
